import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_2 = {
  class: "text-sm text-slate-500 mt-0.5"
};
const _hoisted_3 = {
  class: "flex-1 overflow-y-auto min-h-0 p-6"
};
const _hoisted_4 = {
  class: "max-w-xl mx-auto space-y-5"
};
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = {
  class: "text-xs text-slate-400 mt-1"
};
const _hoisted_7 = {
  class: "flex-shrink-0 flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200"
};
const _hoisted_8 = ["disabled"];
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
import { applyRefund, getBillingRefundView } from '@/api/refund';
export default {
  __name: 'RefundApplyModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    billing: {
      type: Object,
      default: null
    }
  },
  emits: ['close', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const submitting = ref(false);
    const refundView = ref(null);
    const form = reactive({
      refundAmount: '',
      refundReason: ''
    });
    const maxRefundable = computed(() => {
      // paidAmount 已被后端冲正扣减（即剩余已收），上限 = 当前已收余额 − 退款中占用，不再减累计已退
      const paid = Number(props.billing?.paidAmount) || 0;
      const inFlight = Number(refundView.value?.inFlightRefundAmount) || 0;
      // toFixed(2) 归一，避免浮点误差导致边界金额被误判超限
      return Number(Math.max(0, paid - inFlight).toFixed(2));
    });
    watch(() => props.visible, async visible => {
      if (!visible || !props.billing?.id) return;
      form.refundAmount = '';
      form.refundReason = '';
      refundView.value = null;
      try {
        refundView.value = await getBillingRefundView(props.billing.id);
      } catch (error) {
        // 退款视图加载失败不阻断申请，金额上限退化为已收金额
      }
    });
    const formatAmount = value => {
      const num = Number(value);
      return Number.isFinite(num) ? num.toFixed(2) : '0.00';
    };
    const validateForm = () => {
      const amount = Number(form.refundAmount);
      if (!Number.isFinite(amount) || amount <= 0) {
        ElMessage.warning('请输入正确的退款金额');
        return false;
      }
      if (amount > maxRefundable.value) {
        ElMessage.warning(`退款金额不能超过可退金额 ${formatAmount(maxRefundable.value)} 元`);
        return false;
      }
      if (form.refundReason && form.refundReason.length > 32) {
        ElMessage.warning('退款原因不能超过 32 个字符');
        return false;
      }
      return true;
    };
    const handleSubmit = async () => {
      if (!validateForm()) return;
      submitting.value = true;
      try {
        await applyRefund({
          billingId: props.billing.id,
          refundAmount: Number(form.refundAmount),
          refundReason: form.refundReason || undefined
        });
        ElMessage.success('退款申请已提交，待审批');
        emit('success');
        closeModal();
      } catch (error) {
        ElMessage.error(error.message || '退款申请提交失败');
      } finally {
        submitting.value = false;
      }
    };
    const closeModal = () => {
      emit('close');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.visible,
        size: "lg",
        "z-index": 70,
        onClose: closeModal
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_cache[2] || (_cache[2] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "发起退款", -1)), _createElementVNode("p", _hoisted_2, " 账单 #" + _toDisplayString(__props.billing?.id) + "，已收 " + _toDisplayString(formatAmount(__props.billing?.paidAmount)) + " 元 ", 1)]), _createElementVNode("button", {
          onClick: closeModal,
          class: "p-1.5 text-slate-400 hover:text-slate-600"
        }, [...(_cache[3] || (_cache[3] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_cache[4] || (_cache[4] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode(" 退款金额（元） "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.refundAmount = $event),
          type: "number",
          min: "0.01",
          step: "0.01",
          class: "w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500",
          placeholder: `最多可退 ${formatAmount(maxRefundable.value)} 元`
        }, null, 8, _hoisted_5), [[_vModelText, form.refundAmount]]), _createElementVNode("p", _hoisted_6, " 已收 " + _toDisplayString(formatAmount(__props.billing?.paidAmount)) + " 元， 累计已退 " + _toDisplayString(formatAmount(refundView.value?.totalRefundedAmount)) + " 元， 退款中 " + _toDisplayString(formatAmount(refundView.value?.inFlightRefundAmount)) + " 元 ", 1)]), _createElementVNode("div", null, [_cache[5] || (_cache[5] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, " 退款原因（不超过 32 个字符） ", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.refundReason = $event),
          maxlength: "32",
          class: "w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500",
          placeholder: "请输入退款原因"
        }, null, 512), [[_vModelText, form.refundReason]])]), _cache[6] || (_cache[6] = _createElementVNode("p", {
          class: "text-xs text-amber-600 bg-amber-50 rounded-lg px-3 py-2"
        }, " 退款申请提交后需审批通过才会执行退款，退款金额上限 = 当前已收余额 − 退款中占用。 ", -1))])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
          onClick: closeModal,
          class: "px-4 py-2 text-sm text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
        }, " 取消 "), _createElementVNode("button", {
          onClick: handleSubmit,
          disabled: submitting.value,
          class: "px-5 py-2.5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        }, _toDisplayString(submitting.value ? '提交中...' : '提交退款申请'), 9, _hoisted_8)])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};